import {Component, EventEmitter, forwardRef, Input, Output} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

import { SearchFilterMetadataModel } from "../../../models/search-filter-metadata.model";

@Component({
    selector: "pcg-ng-directory-section-filter",
    templateUrl: "directory-section-filter.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DirectorySectionFilterComponent),
            multi: true
        }
    ]
})
export class DirectorySectionFilterComponent implements ControlValueAccessor {
    @Input() public filterModel: SearchFilterMetadataModel;
    @Output() public searchTabChange = new EventEmitter<string>();

    protected selectedSectionId: string;
    protected isSearchTabContent = false;

    private onChange: (value: any) => void;
    private onTouched: () => void;

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public writeValue(obj: any): void {
        this.selectedSectionId = obj;
    }

    protected toggleCheckbox(sectionId: string): void {
        if (this.selectedSectionId === sectionId) {
            this.writeValue(null);
        } else {
            this.writeValue(sectionId);
        }

        this.onChange(this.selectedSectionId);
    }

    protected toggleSearchTab(event: Event, searchTab: string): void {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.isSearchTabContent = isChecked;

        if (isChecked) {
            this.searchTabChange.emit(searchTab);
        }
    }
}
